import React, { useState } from "react";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline"; // optional for icon usage
import email from "./assets/about_us/email.png";

import Footer from "./footer";

const Contact = () => {
  const [result, setResult] = React.useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "8ca40902-ab61-4887-8b76-da788a58bc21");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      setFormData({ name: "", email: "", message: "" });
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          bgcolor: "#f9f9f9",
          minHeight: "100vh",
          py: 4,
          pl: { xs: 2, md: 0 },
          pr: { xs: 2, md: 0 },
          mt: { xs: 2, md: 0 },
        }}
      >
        <Box display="flex" justifyContent="center" mb={3}>
          <img
            src={email}
            alt="Mail Icon"
            style={{ width: 100, height: 100 }}
          />
        </Box>
        <Box
          maxWidth="600px"
          mx="auto"
          component={Paper}
          elevation={3}
          sx={{ p: 4, borderRadius: 3, mb: 4 }}
        >
          <Typography
            variant="h4"
            gutterBottom
            fontWeight="bold"
            textAlign="center"
          >
            Contact Us
          </Typography>
          <form onSubmit={onSubmit}>
            <TextField
              fullWidth
              label="Your Name"
              name="name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              required
              margin="normal"
              variant="outlined"
            />
            <TextField
              fullWidth
              label="Your Email"
              name="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              required
              type="email"
              margin="normal"
              variant="outlined"
            />
            <TextField
              fullWidth
              label="Your Message"
              name="message"
              value={formData.message}
              onChange={(e) =>
                setFormData({ ...formData, message: e.target.value })
              }
              required
              multiline
              rows={5}
              margin="normal"
              variant="outlined"
            />

            <Button
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
              sx={{ mt: 2, py: 1.5, fontWeight: "bold", fontSize: "16px" }}
            >
              Submit
            </Button>
          </form>
          <Typography
            variant="body2"
            color="green"
            mt={2}
            textAlign="center"
            minHeight="24px"
          >
            {result}
          </Typography>
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default Contact;
